import { Filters, PositionInfo } from './user-preferences';
import { ListingCategory, NotificationFrequency } from './enums';

export class SavedSearch {
  id: string;
  encryptedId: string;
  userId: string;
  encryptedUserId: string;
  name: string;
  positionInfo: PositionInfo;
  filters: Filters;
  listingCategory: ListingCategory;
  notificationsEnabled: boolean;
  notificationsFrequency: NotificationFrequency;

  // String description of where the location is near - maybe it goes into positionInfo?
  nearby?: string;

  static trackBy(index, elem: SavedSearch) {
    return elem.name;
  }
};
